import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import {
  NoReqs,
  Requirement,
} from 'modules/for-verification/components/VerificationDetails';
import { isJson } from 'helper';
import { get, upperCase } from 'lodash';
import Badges from 'modules/common/components/Badge';

function Verification() {
  const { id } = useParams();
  const [isLoading, subscriber] = useShowSubscriber(id);
  const organization = get(subscriber, 'organization');
  const requirementsRaw = get(organization, 'requirements');

  const requirements = useMemo(
    () => ({
      ...requirementsRaw,
      government_id: isJson(requirementsRaw?.government_id)
        ? JSON.parse(requirementsRaw?.government_id)
        : requirementsRaw?.government_id,
      secondary_government_id: isJson(requirementsRaw?.secondary_government_id)
        ? JSON.parse(requirementsRaw?.secondary_government_id)
        : requirementsRaw?.secondary_government_id,
    }),
    [requirementsRaw],
  );

  return (
    <div className="w-full flex-1">
      {isLoading ? (
        <div className="grid grid-cols-2 gap-3 p-3">
          <div className="animate-pulse bg-neutral-100 h-8 w-full rounded" />
          <div className="animate-pulse bg-neutral-100 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-neutral-100 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-neutral-100 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-neutral-100 h-8 w-full rounded" />
        </div>
      ) : (
        <div className="flex flex-col gap-6 h-full">
          <div className="w-full flex justify-between items-center">
            <div className="flex flex-col gap-px text-sm">
              {requirements?.remarks && (
                <>
                  <div className="font-bold">Remarks:</div>
                  <div>{requirements?.remarks}</div>
                </>
              )}
            </div>
            {subscriber?.status !== 'No Requirements Passed.' && (
              <Badges
                status={upperCase(subscriber?.status)}
                containerClassName="!text-sm !px-8 w-fit"
              />
            )}
          </div>
          {requirementsRaw ? (
            <div className="space-y-5">
              <div>
                <div className="text-sm text-neutral-900/60">
                  Government ID:
                </div>
                <div className="rounded mt-1 p-3 border border-neutral-200/60 w-full">
                  <Requirement req={requirements?.government_id} />
                </div>
              </div>
              <div>
                <div className="text-sm text-neutral-900/60">
                  Secondary Government ID:
                </div>
                <div className="rounded mt-1 p-3 border border-neutral-200/60 w-full">
                  <Requirement req={requirements?.secondary_government_id} />
                </div>
              </div>
            </div>
          ) : (
            <NoReqs />
          )}
        </div>
      )}
    </div>
  );
}

export default Verification;
